import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=38682866&scoped=true&"
import script from "./MyProfile.vue?vue&type=script&lang=js&"
export * from "./MyProfile.vue?vue&type=script&lang=js&"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=38682866&prod&lang=scss&scoped=true&"
import style1 from "./MyProfile.vue?vue&type=style&index=1&id=38682866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38682866",
  null
  
)

export default component.exports